import React, { Component } from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import { Icon } from 'semantic-ui-react';
import { getIconAndColor } from 'PointOfSale/modules/common/helpers';

class ProfileSymbolIndicator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileIndicatorOpenStatus: {
        queuedDirection: false,
        manuallyKeyed: false,
        allergensIndicator: false,
        specialMessage: false,
        invalidStudent: false,
      },
    };
  }

  handleOpen = keyValue => {
    const profileIndicatorOpenStatus = {
      queuedDirection: false,
      manuallyKeyed: false,
      allergensIndicator: false,
      specialMessage: false,
      invalidStudent: false,
    };
    profileIndicatorOpenStatus[keyValue] = true;
    this.setState({ profileIndicatorOpenStatus });
  };

  handleClose = () => {
    const profileIndicatorOpenStatus = {
      queuedDirection: false,
      manuallyKeyed: false,
      allergensIndicator: false,
      specialMessage: false,
      invalidStudent: false,
    };
    this.setState({ profileIndicatorOpenStatus });
  };

  render() {
    const { symbolIndicator } = this.props;

    return (
      <div className="button-container">
        {symbolIndicator.map((item, index) => {
          var symbol = getIconAndColor(item);
          return (
            <span className={symbol.className} key={shortid.generate()}>
              <Icon name={symbol.name} color={symbol.color} size={'huge'} />
            </span>
          );
        })}
      </div>
    );
  }
}

ProfileSymbolIndicator.propTypes = {
  symbolIndicator: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string,
      type: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      isOpen: PropTypes.bool.isRequired,
    })
  ).isRequired,
};

export default ProfileSymbolIndicator;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/component/ProfileSymbolIndicator.js